import apolloClient from '../../utils/apollo-client';
import { createFile as mutation } from '../graphql/file';

export default async function createFile(fileName, fileExtension, contentType) {
  const response = await apolloClient().then((client) => {
    return client.mutate({
      mutation,
      variables: {
        fileName,
        fileExtension,
        contentType
      }
    });
  });
  return response.data.createFile;
}
